import { z } from 'zod';
import { INDUSTRY_KEYS } from '../industries';
import { optionalPhone, optionalText, passwordSchema, requiredEmail, workspaceSlugSchema } from './common';

export const registerCompanySchema = z.object({
  companyName: z.string().trim().min(2).max(120),
  workspace: workspaceSlugSchema,
  industry: z.enum(INDUSTRY_KEYS),
  ownerName: z.string().trim().min(2).max(100),
  email: requiredEmail(),
  phone: optionalPhone(),
  password: passwordSchema,
  branchName: optionalText(100),
  timezone: z.string().trim().max(60).default('Asia/Kolkata'),
  currency: z.string().trim().length(3).toUpperCase().default('INR'),
});
export type RegisterCompanyInput = z.input<typeof registerCompanySchema>;

export const loginSchema = z.object({
  workspace: workspaceSlugSchema,
  email: requiredEmail(),
  password: z.string().min(1).max(128),
});
export type LoginInput = z.input<typeof loginSchema>;

export const platformLoginSchema = z.object({
  email: requiredEmail(),
  password: z.string().min(1).max(128),
});

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(128),
  newPassword: passwordSchema,
});
export type ChangePasswordInput = z.input<typeof changePasswordSchema>;
